import { type CandidateLogEntry } from "@vidario/domain";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";

/** Audit trail for a single candidate (MVP_requirements.md §9.2 / §10).
 * Every status change, note, skill-match override and outreach event
 * lands here. Consumed by the CandidateDetail activity sidebar. */
export function useCandidateLog(candidateId: string): UseQueryResult<CandidateLogEntry[]> {
  const client = useVidarioClient();
  return useQuery({
    queryKey: ["candidates", candidateId, "log"],
    queryFn: () => client.getCandidateLog(candidateId),
    enabled: Boolean(candidateId),
  });
}
